import FlexLayout from "../../../controls/FlexLayout";
import Modal from "../../../controls/Modal";
import Spinner from "../../../controls/Spinner";
import { IconButton } from "../../../controls/TooltipControls";
import ZoomableImage from "../../../controls/ZoomableImage";
import { connect, PureComponentEx, translate, } from "../../../controls/ComponentEx";
import { pushSafe, removeValue } from "../../../util/storeHelper";
import { truthy } from "../../../util/util";
import update from "immutability-helper";
import * as _ from "lodash";
import * as React from "react";
import { Button, Checkbox, ControlLabel, Form, FormGroup, ProgressBar, Radio, } from "react-bootstrap";
import { pathToFileURL } from "url";
import { hasSessionFOMOD } from "../utils/guards";
import path from "path";
const nop = () => undefined;
class Group extends React.PureComponent {
    mValidate = (selected) => undefined;
    constructor(props) {
        super(props);
        this.state = {
            selectedPlugins: this.getSelectedPlugins(props),
            localUpdate: 0,
            sentUpdate: 0,
            confirmedUpdate: 1,
        };
    }
    componentDidUpdate(oldProps, oldState) {
        const { group, onSelect } = this.props;
        const { confirmedUpdate, localUpdate, sentUpdate, selectedPlugins } = this.state;
        const valid = this.validateFunc(group.type)(selectedPlugins);
        if (selectedPlugins !== oldState.selectedPlugins &&
            localUpdate > sentUpdate &&
            // if the confirmation is still pending, don't send now
            confirmedUpdate >= sentUpdate) {
            onSelect(group.id, selectedPlugins, valid === undefined);
            this.setState(update(this.state, { sentUpdate: { $set: Date.now() } }));
        }
        if (!_.isEqual(oldProps.group, this.props.group)) {
            // based on the rules of the fomod, us selecting an option may make other options
            // unavailable. However, for usability reasons, we don't undo user selections if the user
            // has made further changes since last sending an update
            if (this.state.sentUpdate >= this.state.localUpdate) {
                this.setState(update(this.state, {
                    selectedPlugins: { $set: this.getSelectedPlugins(this.props) },
                    confirmedUpdate: { $set: Date.now() },
                }));
            }
            else if (this.state.localUpdate > this.state.sentUpdate) {
                // while confirmation was pending, the user made further changes, validate them now
                const { group, onSelect } = this.props;
                const { selectedPlugins } = this.state;
                const valid = this.validateFunc(group.type)(selectedPlugins);
                onSelect(group.id, selectedPlugins, valid === undefined);
                this.setState(update(this.state, { sentUpdate: { $set: Date.now() } }));
            }
            this.mValidate = this.validateFunc(this.props.group.type);
        }
    }
    componentDidMount() {
        const { group, onSelect } = this.props;
        const { selectedPlugins } = this.state;
        this.mValidate = this.validateFunc(group.type);
        if (this.mValidate(selectedPlugins) !== undefined) {
            onSelect(group.id, selectedPlugins, false);
        }
    }
    render() {
        const { t, disabled, group } = this.props;
        const { selectedPlugins } = this.state;
        const validationMessage = this.mValidate(selectedPlugins);
        const validationState = validationMessage === undefined ? null : "error";
        return (React.createElement(FormGroup, { disabled: disabled, validationState: validationState },
            React.createElement(ControlLabel, null,
                group?.name ?? `<${t("Missing group name")}>`,
                " ",
                validationMessage ? `(${validationMessage})` : null),
            this.renderNoneOption(),
            group.options.map(this.renderPlugin)));
    }
    getSelectedPlugins(props) {
        return props.group.options
            .filter((plugin) => plugin.selected)
            .map((plugin) => plugin.id);
    }
    validateFunc(type) {
        const { t } = this.props;
        switch (type) {
            case "SelectAtLeastOne":
                return (selected) => selected.length === 0 ? t("Select at least one") : undefined;
            case "SelectAtMostOne":
                return (selected) => selected.length > 1 ? t("Select at most one") : undefined;
            case "SelectExactlyOne":
                return (selected) => selected.length !== 1 ? t("Select exactly one") : undefined;
            default:
                return () => undefined;
        }
    }
    renderNoneOption = () => {
        const { t, disabled, group, stepId } = this.props;
        const { selectedPlugins } = this.state;
        if (group.type !== "SelectAtMostOne") {
            return null;
        }
        const isSelected = selectedPlugins.length === 0;
        return (React.createElement(Radio, { id: `radio-${stepId}-${group.id}-none`, key: "none", disabled: disabled, name: group.id.toString(), "data-value": "none", checked: isSelected, onChange: this.select }, t("None")));
    };
    renderPlugin = (plugin) => {
        const { t, disabled, group, stepId } = this.props;
        const { selectedPlugins } = this.state;
        const isSelected = selectedPlugins.includes(plugin.id);
        const id = `${stepId}-${group.id}-${plugin.id}`;
        const readOnly = plugin.type === "Required";
        const content = (React.createElement("a", { className: "fake-link", "data-value": plugin.id, onMouseOver: this.showDescription },
            plugin.name,
            plugin.preset ? ` (${t("Preset")})` : ""));
        switch (group.type) {
            case "SelectExactlyOne":
            case "SelectAtMostOne":
                return (React.createElement(Radio, { id: "radio-" + id, key: plugin.id, "data-value": plugin.id, name: group.id.toString(), checked: isSelected, onChange: readOnly ? nop : this.select, disabled: disabled || plugin.type === "NotUsable", title: plugin.conditionMsg }, content));
            case "SelectAll":
                return (React.createElement(Checkbox, { id: "checkbox-" + id, key: plugin.id, checked: isSelected, "data-value": plugin.id, disabled: true }, content));
            default:
                return (React.createElement(Checkbox, { id: "checkbox-" + id, key: plugin.id, "data-value": plugin.id, checked: isSelected, disabled: disabled || plugin.type === "NotUsable", onChange: readOnly ? nop : this.select, title: plugin.conditionMsg }, content));
        }
    };
    showDescription = (evt) => {
        const { group, onShowDescription } = this.props;
        const pluginId = parseInt(evt.currentTarget.getAttribute("data-value"), 10);
        const { image, description } = group.options[pluginId];
        onShowDescription(image, description);
    };
    select = (evt) => {
        const { group, onShowDescription } = this.props;
        const value = evt.currentTarget.getAttribute("data-value");
        if (value === "none") {
            this.setState(update(this.state, {
                selectedPlugins: { $set: [] },
                localUpdate: { $set: Date.now() },
            }));
            onShowDescription(undefined, undefined);
            return;
        }
        const pluginId = parseInt(value, 10);
        this.showDescription(evt);
        if (["SelectExactlyOne", "SelectAtMostOne"].indexOf(group.type) !== -1) {
            this.setState(update(this.state, {
                selectedPlugins: { $set: [pluginId] },
                localUpdate: { $set: Date.now() },
            }));
        }
        else if (this.state.selectedPlugins.indexOf(pluginId) === -1) {
            this.setState(update(this.state, {
                selectedPlugins: {
                    $set: Array().concat(this.state.selectedPlugins, [
                        pluginId,
                    ]),
                },
                localUpdate: { $set: Date.now() },
            }));
        }
        else {
            this.setState(update(this.state, {
                selectedPlugins: {
                    $set: this.state.selectedPlugins.filter((iter) => iter !== pluginId),
                },
                localUpdate: { $set: Date.now() },
            }));
        }
    };
}
function getGroupSortFunc(order) {
    if (order === "AlphaDesc") {
        return (lhs, rhs) => rhs.name.localeCompare(lhs.name);
    }
    else {
        return (lhs, rhs) => lhs.name.localeCompare(rhs.name);
    }
}
function Step(props) {
    let groupsSorted;
    if (props.step.optionalFileGroups?.group === undefined) {
        return null;
    }
    if (props.step.optionalFileGroups.order === "Explicit") {
        groupsSorted = props.step.optionalFileGroups.group;
    }
    else {
        const sortFunc = getGroupSortFunc(props.step.optionalFileGroups.order);
        groupsSorted = props.step.optionalFileGroups.group.slice(0).sort(sortFunc);
    }
    return (React.createElement(Form, { disabled: props.disabled, id: "fomod-installer-form" }, groupsSorted.map((group) => (React.createElement(Group, { t: props.t, disabled: props.disabled, key: `${props.step.id}-${group.id}`, stepId: props.step.id, group: group, onSelect: props.onSelect, onShowDescription: props.onShowDescription })))));
}
class InstallerDialog extends PureComponentEx {
    constructor(props) {
        super(props);
        this.state = this.initDescription(props);
    }
    componentDidUpdate(prevProps) {
        if (
        // when initiating the dialog
        (prevProps.installerState === undefined &&
            this.props.installerState !== undefined) ||
            // and any time we change to a different page (forward or backwards)
            (prevProps.installerState !== undefined &&
                this.props.installerState !== undefined &&
                (prevProps.installerInfo !== this.props.installerInfo ||
                    prevProps.installerState.currentStep !==
                        this.props.installerState.currentStep))) {
            // fully update the description
            this.setState(this.initDescription(this.props));
        }
    }
    render() {
        const { t, installerInfo, installerState, activeInstanceId } = this.props;
        const { currentDescription, waiting } = this.state;
        if (!truthy(installerState)) {
            return null;
        }
        // Use default values if installerInfo is missing
        const moduleName = installerInfo?.moduleName || "FOMOD Installer";
        const hasImage = installerInfo?.image?.path;
        const idx = installerState.currentStep;
        const steps = installerState.installSteps;
        const nextVisible = steps.find((step, i) => i > idx && step.visible);
        let lastVisible;
        steps.forEach((step, i) => {
            if (i < idx && step.visible) {
                lastVisible = step;
            }
        });
        const nextDisabled = this.state.invalidGroups.length > 0;
        return (React.createElement(Modal, { id: "fomod-installer-dialog", show: activeInstanceId != null, onHide: this.cancel, backdrop: "static" },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, moduleName),
                steps[idx].name,
                React.createElement(IconButton, { id: "fomod-cancel", className: "close-button", tooltip: t("Cancel"), icon: "close", onClick: this.cancel })),
            React.createElement(Modal.Body, null,
                React.createElement(FlexLayout, { type: "row", style: { position: "relative" } },
                    React.createElement(FlexLayout.Flex, { fill: true, style: { overflowY: "auto" } },
                        React.createElement(Step, { t: t, step: steps[idx], onSelect: this.select, onShowDescription: this.showDescription, disabled: waiting })),
                    React.createElement(FlexLayout.Fixed, { style: { maxWidth: "60%", minWidth: "40%", overflowY: "auto" } },
                        React.createElement(FlexLayout, { type: "column" },
                            React.createElement(FlexLayout.Flex, null, this.renderImage()),
                            React.createElement(FlexLayout.Flex, { fill: true, className: "description" },
                                React.createElement(ControlLabel, { readOnly: true }, currentDescription)))))),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "fomod-nav-buttons" },
                    React.createElement("div", null, lastVisible !== undefined ? (React.createElement(Button, { onClick: this.prev, disabled: waiting }, waiting ? React.createElement(Spinner, null) : lastVisible.name || t("Previous"))) : null),
                    React.createElement("div", { className: "fomod-progress" },
                        React.createElement(ProgressBar, { now: idx, max: steps.length - 1 })),
                    React.createElement("div", null, nextVisible !== undefined ? (React.createElement(Button, { disabled: nextDisabled || waiting, onClick: this.next }, waiting ? React.createElement(Spinner, null) : nextVisible.name || t("Next"))) : (React.createElement(Button, { disabled: nextDisabled || waiting, onClick: this.next }, t("Finish"))))))));
    }
    select = (groupId, plugins, valid) => {
        const { events } = this.context.api;
        const { activeInstanceId, installerState } = this.props;
        let newState = this.state;
        newState = valid
            ? removeValue(newState, ["invalidGroups"], groupId)
            : pushSafe(newState, ["invalidGroups"], groupId);
        events.emit(`fomod-installer-select-${activeInstanceId}`, installerState.installSteps[installerState.currentStep].id, groupId, plugins);
        this.setState(newState);
    };
    renderImage = () => {
        const { installerInfo } = this.props;
        const { currentImage } = this.state;
        const image = currentImage || installerInfo?.image?.path;
        if (!truthy(installerInfo?.dataPath) || !truthy(image)) {
            return null;
        }
        return (React.createElement(ZoomableImage, { url: pathToFileURL(path.join(installerInfo.dataPath, image)).href, className: "installer-image", overlayClass: "installer-zoom", container: undefined }));
    };
    initDescription(props) {
        const ret = (option) => ({
            invalidGroups: [],
            currentImage: option?.image,
            currentDescription: option?.description,
            waiting: false,
        });
        if (!truthy(props.installerState)) {
            return ret(undefined);
        }
        const { currentStep, installSteps } = props.installerState;
        const selOption = (installSteps[currentStep]?.optionalFileGroups?.group?.[0]?.options ?? []).find((opt) => opt.selected);
        return ret(selOption || undefined);
    }
    showDescription = (image, description) => {
        this.setState(update(this.state, {
            currentDescription: { $set: description || "" },
            currentImage: { $set: image || "" },
        }));
    };
    prev = () => {
        const { events } = this.context.api;
        const { activeInstanceId } = this.props;
        this.setState(update(this.state, {
            waiting: { $set: true },
        }));
        // Emit instance-specific event if instanceId is available, otherwise use global event
        events.emit(`fomod-installer-continue-${activeInstanceId}`, "back", this.props.installerState.currentStep);
    };
    next = () => {
        const { events } = this.context.api;
        const { activeInstanceId, installerState } = this.props;
        this.setState(update(this.state, {
            waiting: { $set: true },
        }));
        const idx = installerState.currentStep;
        const steps = installerState.installSteps;
        const nextVisible = steps.find((step, i) => i > idx && step.visible);
        const direction = nextVisible ? "forward" : "finish";
        events.emit(`fomod-installer-continue-${activeInstanceId}`, direction, this.props.installerState.currentStep);
    };
    cancel = () => {
        const { events } = this.context.api;
        const { activeInstanceId } = this.props;
        events.emit(`fomod-installer-cancel-${activeInstanceId}`);
    };
}
function mapStateToProps(state) {
    if (!state || !hasSessionFOMOD(state.session)) {
        return {
            installerInfo: undefined,
            installerState: undefined,
            activeInstanceId: undefined,
        };
    }
    // Use instance-specific state if available, fall back to legacy state for compatibility
    const activeInstanceId = state.session.fomod.installer?.dialog?.activeInstanceId;
    const instanceData = state.session.fomod.installer?.dialog?.instances?.[activeInstanceId];
    return {
        installerInfo: instanceData?.info,
        installerState: instanceData?.state,
        activeInstanceId,
    };
}
export default translate(["common"])(connect(mapStateToProps)(InstallerDialog));
